import {
  Box,
  Paper,
  Button,
  Typography,
  IconButton,
  InputAdornment,
} from '@mui/material';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import _ from 'lodash';
import logo from '@assets/logo_landing_page.svg';
import { useRegister } from './hooks';
import { Form, FormProvider } from 'react-hook-form';
import { TextFormField } from '@components';

export const Register = () => {
  const { toggleShowPassword, onSubmit, formMethods, loading, showPassword } =
    useRegister();

  const { control } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <Form
        control={control}
        onSubmit={e => onSubmit(e.event)}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '3.5rem',
            width: '28rem',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <img
              src={logo}
              style={{
                objectFit: 'cover',
                height: '131px',
                width: '132px',
              }}
              alt='logo'
            />
          </Box>
          <Paper
            elevation={8}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '2rem',
              gap: '2rem',
              width: '100%',
              borderRadius: 0,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem',
                paddingBottom: '1rem',
              }}
            >
              <VpnKeyIcon sx={{ fontSize: '3rem' }} color='primary' />
              <Typography
                variant='h5'
                sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
              >
                Create your password
              </Typography>
            </Box>

            <TextFormField
              label='Email'
              variant='outlined'
              type='email'
              name='email'
              helperText={
                'Use corporate email address e.g. @brigadehealth.com or @seniordoc.com'
              }
              disabled
              required
            />

            <TextFormField
              label='Password'
              variant='outlined'
              type={showPassword ? 'text' : 'password'}
              name='password'
              required
              fullWidth
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label={
                          showPassword
                            ? 'hide the password'
                            : 'display the password'
                        }
                        onClick={toggleShowPassword}
                        edge='end'
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />

            <TextFormField
              label='Confirm password'
              variant='outlined'
              type={showPassword ? 'text' : 'password'}
              name='confirm'
              required
              fullWidth
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label={
                          showPassword
                            ? 'hide the password'
                            : 'display the password'
                        }
                        onClick={toggleShowPassword}
                        edge='end'
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />

            <Button
              variant='contained'
              type='submit'
              color='secondary'
              sx={{ color: 'white', padding: '0.5rem', fontWeight: '500' }}
              disabled={loading}
            >
              SAVE
            </Button>
          </Paper>
        </Box>
      </Form>
    </FormProvider>
  );
};
